// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/home/services/impact.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/home/services/bg_cover.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.mainDivView {
  padding: 4vw 6vw 0vw 6vw;
}

.cardView {
  border-radius: 20px 20px 20px 20px;
  height: 100% !important;
  padding: 0 !important;
}

.cardView .cardView0 {
  background: linear-gradient(135deg, #fff2e6 0%, #ffe3d9 100%);
  padding: 1rem 1rem 0vw 1rem;
  border-radius: 18px 18px 0px 0px;
  margin: 0.2rem;
}
@media (max-width: 576px) {
  .cardView .cardView0 h5 {
    text-align: center;
    margin-bottom: 2rem;
  }
}
.cardView .buttonSection {
  padding: 1rem 2rem 1rem 2rem;
}
.cardView .buttonSection .button0 {
  background: linear-gradient(135deg, #fff2e6 0%, #ffe3d9 100%);
  border: none !important;
  color: #201b36 !important;
  float: right;
}
.cardView .buttonSection .button0:hover {
  background: linear-gradient(135deg, #fff2e6 0%, #ffe3d9 100%);
  border: 1px solid #201b36 !important;
}
.cardView .buttonSection button {
  background-color: #201b36 !important;
  color: #FFF !important;
}
.technologies0 {
  border-color: #85DBF6 !important;
  margin-bottom: 0.4rem;
  background-color: #FFF !important;
  color: #201b36 !important;
  padding: 0.2rem 1rem 0.2rem 1rem;
  border-radius: 25px;
}

.cardView .cardView1 {
  background: linear-gradient(135deg, #e3efff 0%, #eaf6ff 100%);
  padding: 1rem 1rem 0vw 1rem;
  border-radius: 18px 18px 0px 0px;
  margin: 0.2rem;
}
@media (max-width: 576px) {
  .cardView .cardView1 h5 {
    text-align: center;
    margin-bottom: 2rem;
  }
}
.cardView .buttonSection {
  padding: 1rem 2rem 1rem 2rem;
}
.cardView .buttonSection .button1 {
  background: linear-gradient(135deg, #e3efff 0%, #eaf6ff 100%);
  border: none !important;
  color: #201b36 !important;
  float: right;
}
.cardView .buttonSection .button1:hover {
  background: linear-gradient(135deg, #e3efff 0%, #eaf6ff 100%);
  border: 1px solid #201b36 !important;
}
.cardView .buttonSection button {
  background-color: #201b36 !important;
  color: #FFF !important;
}
.technologies1 {
  border-color: #F5B8FF !important;
  margin-bottom: 0.4rem;
  background-color: #FFF !important;
  color: #201b36 !important;
  padding: 0.2rem 1rem 0.2rem 1rem;
  border-radius: 25px;
}

.cardView .cardView2 {
  background: linear-gradient(135deg, #fdeafb 0%, #ebf0ff 100%);
  padding: 1rem 1rem 0vw 1rem;
  border-radius: 18px 18px 0px 0px;
  margin: 0.2rem;
}
@media (max-width: 576px) {
  .cardView .cardView2 h5 {
    text-align: center;
    margin-bottom: 2rem;
  }
}
.cardView .buttonSection {
  padding: 1rem 2rem 1rem 2rem;
}
.cardView .buttonSection .button2 {
  background: linear-gradient(135deg, #fdeafb 0%, #ebf0ff 100%);
  border: none !important;
  color: #201b36 !important;
  float: right;
}
.cardView .buttonSection .button2:hover {
  background: linear-gradient(135deg, #fdeafb 0%, #ebf0ff 100%);
  border: 1px solid #201b36 !important;
}
.cardView .buttonSection button {
  background-color: #201b36 !important;
  color: #FFF !important;
}
.technologies2 {
  border-color: #FEC596 !important;
  margin-bottom: 0.4rem;
  background-color: #FFF !important;
  color: #201b36 !important;
  padding: 0.2rem 1rem 0.2rem 1rem;
  border-radius: 25px;
}

.cardView .cardView3 {
  background: linear-gradient(135deg, #f6ffe0 0%, #e4fbe8 100%);
  padding: 1rem 1rem 0vw 1rem;
  border-radius: 18px 18px 0px 0px;
  margin: 0.2rem;
}
@media (max-width: 576px) {
  .cardView .cardView3 h5 {
    text-align: center;
    margin-bottom: 2rem;
  }
}
.cardView .buttonSection {
  padding: 1rem 2rem 1rem 2rem;
}
.cardView .buttonSection .button3 {
  background: linear-gradient(135deg, #f6ffe0 0%, #e4fbe8 100%);
  border: none !important;
  color: #201b36 !important;
  float: right;
}
.cardView .buttonSection .button3:hover {
  background: linear-gradient(135deg, #f6ffe0 0%, #e4fbe8 100%);
  border: 1px solid #201b36 !important;
}
.cardView .buttonSection button {
  background-color: #201b36 !important;
  color: #FFF !important;
}
.technologies3 {
  border-color: #85DBF6 !important;
  margin-bottom: 0.4rem;
  background-color: #FFF !important;
  color: #201b36 !important;
  padding: 0.2rem 1rem 0.2rem 1rem;
  border-radius: 25px;
}

.cardView .cardView4 {
  background: linear-gradient(135deg, #e6fff2 0%, #ebfaff 100%);
  padding: 1rem 1rem 0vw 1rem;
  border-radius: 18px 18px 0px 0px;
  margin: 0.2rem;
}
@media (max-width: 576px) {
  .cardView .cardView4 h5 {
    text-align: center;
    margin-bottom: 2rem;
  }
}
.cardView .buttonSection {
  padding: 1rem 2rem 1rem 2rem;
}
.cardView .buttonSection .button4 {
  background: linear-gradient(135deg, #e6fff2 0%, #ebfaff 100%);
  border: none !important;
  color: #201b36 !important;
  float: right;
}
.cardView .buttonSection .button4:hover {
  background: linear-gradient(135deg, #e6fff2 0%, #ebfaff 100%);
  border: 1px solid #201b36 !important;
}
.cardView .buttonSection button {
  background-color: #201b36 !important;
  color: #FFF !important;
}
.technologies4 {
  border-color: #F5B8FF !important;
  margin-bottom: 0.4rem;
  background-color: #FFF !important;
  color: #201b36 !important;
  padding: 0.2rem 1rem 0.2rem 1rem;
  border-radius: 25px;
}

.cardView .cardView5 {
  background: linear-gradient(135deg, #ffe5e7 0%, #fff1ed 100%);
  padding: 1rem 1rem 0vw 1rem;
  border-radius: 18px 18px 0px 0px;
  margin: 0.2rem;
}
@media (max-width: 576px) {
  .cardView .cardView5 h5 {
    text-align: center;
    margin-bottom: 2rem;
  }
}
.cardView .buttonSection {
  padding: 1rem 2rem 1rem 2rem;
}
.cardView .buttonSection .button5 {
  background: linear-gradient(135deg, #ffe5e7 0%, #fff1ed 100%);
  border: none !important;
  color: #201b36 !important;
  float: right;
}
.cardView .buttonSection .button5:hover {
  background: linear-gradient(135deg, #ffe5e7 0%, #fff1ed 100%);
  border: 1px solid #201b36 !important;
}
.cardView .buttonSection button {
  background-color: #201b36 !important;
  color: #FFF !important;
}
.technologies5 {
  border-color: #FEC596 !important;
  margin-bottom: 0.4rem;
  background-color: #FFF !important;
  color: #201b36 !important;
  padding: 0.2rem 1rem 0.2rem 1rem;
  border-radius: 25px;
}

.cardView .cardView6 {
  background: linear-gradient(135deg, #fff7e0 0%, #f1ffff 100%);
  padding: 1rem 1rem 0vw 1rem;
  border-radius: 18px 18px 0px 0px;
  margin: 0.2rem;
}
@media (max-width: 576px) {
  .cardView .cardView6 h5 {
    text-align: center;
    margin-bottom: 2rem;
  }
}
.cardView .buttonSection {
  padding: 1rem 2rem 1rem 2rem;
}
.cardView .buttonSection .button6 {
  background: linear-gradient(135deg, #fff7e0 0%, #f1ffff 100%);
  border: none !important;
  color: #201b36 !important;
  float: right;
}
.cardView .buttonSection .button6:hover {
  background: linear-gradient(135deg, #fff7e0 0%, #f1ffff 100%);
  border: 1px solid #201b36 !important;
}
.cardView .buttonSection button {
  background-color: #201b36 !important;
  color: #FFF !important;
}
.technologies6 {
  border-color: #85DBF6 !important;
  margin-bottom: 0.4rem;
  background-color: #FFF !important;
  color: #201b36 !important;
  padding: 0.2rem 1rem 0.2rem 1rem;
  border-radius: 25px;
}

.cardView .cardView7 {
  background: linear-gradient(135deg, #fff0cc 0%, #ffe5d6 100%);
  padding: 1rem 1rem 0vw 1rem;
  border-radius: 18px 18px 0px 0px;
  margin: 0.2rem;
}
@media (max-width: 576px) {
  .cardView .cardView7 h5 {
    text-align: center;
    margin-bottom: 2rem;
  }
}
.cardView .buttonSection {
  padding: 1rem 2rem 1rem 2rem;
}
.cardView .buttonSection .button7 {
  background: linear-gradient(135deg, #fff0cc 0%, #ffe5d6 100%);
  border: none !important;
  color: #201b36 !important;
  float: right;
}
.cardView .buttonSection .button7:hover {
  background: linear-gradient(135deg, #fff0cc 0%, #ffe5d6 100%);
  border: 1px solid #201b36 !important;
}
.cardView .buttonSection button {
  background-color: #201b36 !important;
  color: #FFF !important;
}
.technologies7 {
  border-color: #F5B8FF !important;
  margin-bottom: 0.4rem;
  background-color: #FFF !important;
  color: #201b36 !important;
  padding: 0.2rem 1rem 0.2rem 1rem;
  border-radius: 25px;
}

.cardView .cardView8 {
  background: linear-gradient(135deg, #ffe6e0 0%, #fff0ee 100%);
  padding: 1rem 1rem 0vw 1rem;
  border-radius: 18px 18px 0px 0px;
  margin: 0.2rem;
}
@media (max-width: 576px) {
  .cardView .cardView8 h5 {
    text-align: center;
    margin-bottom: 2rem;
  }
}
.cardView .buttonSection {
  padding: 1rem 2rem 1rem 2rem;
}
.cardView .buttonSection .button8 {
  background: linear-gradient(135deg, #ffe6e0 0%, #fff0ee 100%);
  border: none !important;
  color: #201b36 !important;
  float: right;
}
.cardView .buttonSection .button8:hover {
  background: linear-gradient(135deg, #ffe6e0 0%, #fff0ee 100%);
  border: 1px solid #201b36 !important;
}
.cardView .buttonSection button {
  background-color: #201b36 !important;
  color: #FFF !important;
}
.technologies8 {
  border-color: #FEC596 !important;
  margin-bottom: 0.4rem;
  background-color: #FFF !important;
  color: #201b36 !important;
  padding: 0.2rem 1rem 0.2rem 1rem;
  border-radius: 25px;
}

.cardView .cardView9 {
  background: linear-gradient(135deg, #ffece3 0%, #fff7f0 100%);
  padding: 1rem 1rem 0vw 1rem;
  border-radius: 18px 18px 0px 0px;
  margin: 0.2rem;
}
@media (max-width: 576px) {
  .cardView .cardView9 h5 {
    text-align: center;
    margin-bottom: 2rem;
  }
}
.cardView .buttonSection {
  padding: 1rem 2rem 1rem 2rem;
}
.cardView .buttonSection .button9 {
  background: linear-gradient(135deg, #ffece3 0%, #fff7f0 100%);
  border: none !important;
  color: #201b36 !important;
  float: right;
}
.cardView .buttonSection .button9:hover {
  background: linear-gradient(135deg, #ffece3 0%, #fff7f0 100%);
  border: 1px solid #201b36 !important;
}
.cardView .buttonSection button {
  background-color: #201b36 !important;
  color: #FFF !important;
}
.technologies9 {
  border-color: #85DBF6 !important;
  margin-bottom: 0.4rem;
  background-color: #FFF !important;
  color: #201b36 !important;
  padding: 0.2rem 1rem 0.2rem 1rem;
  border-radius: 25px;
}

.cardView .cardView10 {
  background: linear-gradient(135deg, #e6fbff 0%, #f0f8ff 100%);
  padding: 1rem 1rem 0vw 1rem;
  border-radius: 18px 18px 0px 0px;
  margin: 0.2rem;
}
@media (max-width: 576px) {
  .cardView .cardView10 h5 {
    text-align: center;
    margin-bottom: 2rem;
  }
}
.cardView .buttonSection {
  padding: 1rem 2rem 1rem 2rem;
}
.cardView .buttonSection .button10 {
  background: linear-gradient(135deg, #e6fbff 0%, #f0f8ff 100%);
  border: none !important;
  color: #201b36 !important;
  float: right;
}
.cardView .buttonSection .button10:hover {
  background: linear-gradient(135deg, #e6fbff 0%, #f0f8ff 100%);
  border: 1px solid #201b36 !important;
}
.cardView .buttonSection button {
  background-color: #201b36 !important;
  color: #FFF !important;
}
.technologies10 {
  border-color: #F5B8FF !important;
  margin-bottom: 0.4rem;
  background-color: #FFF !important;
  color: #201b36 !important;
  padding: 0.2rem 1rem 0.2rem 1rem;
  border-radius: 25px;
}

.cardView .cardView11 {
  background: linear-gradient(135deg, #f0faff 0%, #e6f0ff 100%);
  padding: 1rem 1rem 0vw 1rem;
  border-radius: 18px 18px 0px 0px;
  margin: 0.2rem;
}
@media (max-width: 576px) {
  .cardView .cardView11 h5 {
    text-align: center;
    margin-bottom: 2rem;
  }
}
.cardView .buttonSection {
  padding: 1rem 2rem 1rem 2rem;
}
.cardView .buttonSection .button11 {
  background: linear-gradient(135deg, #f0faff 0%, #e6f0ff 100%);
  border: none !important;
  color: #201b36 !important;
  float: right;
}
.cardView .buttonSection .button11:hover {
  background: linear-gradient(135deg, #f0faff 0%, #e6f0ff 100%);
  border: 1px solid #201b36 !important;
}
.cardView .buttonSection button {
  background-color: #201b36 !important;
  color: #FFF !important;
}
.technologies11 {
  border-color: #FEC596 !important;
  margin-bottom: 0.4rem;
  background-color: #FFF !important;
  color: #201b36 !important;
  padding: 0.2rem 1rem 0.2rem 1rem;
  border-radius: 25px;
}

.cardView .cardView12 {
  background: linear-gradient(135deg, #fff1ee 0%, #fff0fa 100%);
  padding: 1rem 1rem 0vw 1rem;
  border-radius: 18px 18px 0px 0px;
  margin: 0.2rem;
}
@media (max-width: 576px) {
  .cardView .cardView12 h5 {
    text-align: center;
    margin-bottom: 2rem;
  }
}
.cardView .buttonSection {
  padding: 1rem 2rem 1rem 2rem;
}
.cardView .buttonSection .button12 {
  background: linear-gradient(135deg, #fff1ee 0%, #fff0fa 100%);
  border: none !important;
  color: #201b36 !important;
  float: right;
}
.cardView .buttonSection .button12:hover {
  background: linear-gradient(135deg, #fff1ee 0%, #fff0fa 100%);
  border: 1px solid #201b36 !important;
}
.cardView .buttonSection button {
  background-color: #201b36 !important;
  color: #FFF !important;
}
.technologies12 {
  border-color: #85DBF6 !important;
  margin-bottom: 0.4rem;
  background-color: #FFF !important;
  color: #201b36 !important;
  padding: 0.2rem 1rem 0.2rem 1rem;
  border-radius: 25px;
}

.cardView .cardView13 {
  background: linear-gradient(135deg, #f4f0fb 0%, #fff1fa 100%);
  padding: 1rem 1rem 0vw 1rem;
  border-radius: 18px 18px 0px 0px;
  margin: 0.2rem;
}
@media (max-width: 576px) {
  .cardView .cardView13 h5 {
    text-align: center;
    margin-bottom: 2rem;
  }
}
.cardView .buttonSection {
  padding: 1rem 2rem 1rem 2rem;
}
.cardView .buttonSection .button13 {
  background: linear-gradient(135deg, #f4f0fb 0%, #fff1fa 100%);
  border: none !important;
  color: #201b36 !important;
  float: right;
}
.cardView .buttonSection .button13:hover {
  background: linear-gradient(135deg, #f4f0fb 0%, #fff1fa 100%);
  border: 1px solid #201b36 !important;
}
.cardView .buttonSection button {
  background-color: #201b36 !important;
  color: #FFF !important;
}
.technologies13 {
  border-color: #F5B8FF !important;
  margin-bottom: 0.4rem;
  background-color: #FFF !important;
  color: #201b36 !important;
  padding: 0.2rem 1rem 0.2rem 1rem;
  border-radius: 25px;
}

.cardView .cardView14 {
  background: linear-gradient(135deg, #fff3f4 0%, #ffecee 100%);
  padding: 1rem 1rem 0vw 1rem;
  border-radius: 18px 18px 0px 0px;
  margin: 0.2rem;
}
@media (max-width: 576px) {
  .cardView .cardView14 h5 {
    text-align: center;
    margin-bottom: 2rem;
  }
}
.cardView .buttonSection {
  padding: 1rem 2rem 1rem 2rem;
}
.cardView .buttonSection .button14 {
  background: linear-gradient(135deg, #fff3f4 0%, #ffecee 100%);
  border: none !important;
  color: #201b36 !important;
  float: right;
}
.cardView .buttonSection .button14:hover {
  background: linear-gradient(135deg, #fff3f4 0%, #ffecee 100%);
  border: 1px solid #201b36 !important;
}
.cardView .buttonSection button {
  background-color: #201b36 !important;
  color: #FFF !important;
}
.technologies14 {
  border-color: #FEC596 !important;
  margin-bottom: 0.4rem;
  background-color: #FFF !important;
  color: #201b36 !important;
  padding: 0.2rem 1rem 0.2rem 1rem;
  border-radius: 25px;
}

.cardView .cardView15 {
  background: linear-gradient(135deg, #ffeaea 0%, #fff4fa 100%);
  padding: 1rem 1rem 0vw 1rem;
  border-radius: 18px 18px 0px 0px;
  margin: 0.2rem;
}
@media (max-width: 576px) {
  .cardView .cardView15 h5 {
    text-align: center;
    margin-bottom: 2rem;
  }
}
.cardView .buttonSection {
  padding: 1rem 2rem 1rem 2rem;
}
.cardView .buttonSection .button15 {
  background: linear-gradient(135deg, #ffeaea 0%, #fff4fa 100%);
  border: none !important;
  color: #201b36 !important;
  float: right;
}
.cardView .buttonSection .button15:hover {
  background: linear-gradient(135deg, #ffeaea 0%, #fff4fa 100%);
  border: 1px solid #201b36 !important;
}
.cardView .buttonSection button {
  background-color: #201b36 !important;
  color: #FFF !important;
}
.technologies15 {
  border-color: #85DBF6 !important;
  margin-bottom: 0.4rem;
  background-color: #FFF !important;
  color: #201b36 !important;
  padding: 0.2rem 1rem 0.2rem 1rem;
  border-radius: 25px;
}

.cardView .cardView16 {
  background: linear-gradient(135deg, #f4fff7 0%, #f7fff9 100%);
  padding: 1rem 1rem 0vw 1rem;
  border-radius: 18px 18px 0px 0px;
  margin: 0.2rem;
}
@media (max-width: 576px) {
  .cardView .cardView16 h5 {
    text-align: center;
    margin-bottom: 2rem;
  }
}
.cardView .buttonSection {
  padding: 1rem 2rem 1rem 2rem;
}
.cardView .buttonSection .button16 {
  background: linear-gradient(135deg, #f4fff7 0%, #f7fff9 100%);
  border: none !important;
  color: #201b36 !important;
  float: right;
}
.cardView .buttonSection .button16:hover {
  background: linear-gradient(135deg, #f4fff7 0%, #f7fff9 100%);
  border: 1px solid #201b36 !important;
}
.cardView .buttonSection button {
  background-color: #201b36 !important;
  color: #FFF !important;
}
.technologies16 {
  border-color: #F5B8FF !important;
  margin-bottom: 0.4rem;
  background-color: #FFF !important;
  color: #201b36 !important;
  padding: 0.2rem 1rem 0.2rem 1rem;
  border-radius: 25px;
}

.cardView .cardView17 {
  background: linear-gradient(135deg, #ffffff 0%, #f6f8fa 100%);
  padding: 1rem 1rem 0vw 1rem;
  border-radius: 18px 18px 0px 0px;
  margin: 0.2rem;
}
@media (max-width: 576px) {
  .cardView .cardView17 h5 {
    text-align: center;
    margin-bottom: 2rem;
  }
}
.cardView .buttonSection {
  padding: 1rem 2rem 1rem 2rem;
}
.cardView .buttonSection .button17 {
  background: linear-gradient(135deg, #ffffff 0%, #f6f8fa 100%);
  border: none !important;
  color: #201b36 !important;
  float: right;
}
.cardView .buttonSection .button17:hover {
  background: linear-gradient(135deg, #ffffff 0%, #f6f8fa 100%);
  border: 1px solid #201b36 !important;
}
.cardView .buttonSection button {
  background-color: #201b36 !important;
  color: #FFF !important;
}
.technologies17 {
  border-color: #FEC596 !important;
  margin-bottom: 0.4rem;
  background-color: #FFF !important;
  color: #201b36 !important;
  padding: 0.2rem 1rem 0.2rem 1rem;
  border-radius: 25px;
}

.centerButton {
  margin-top: 4vw;
  padding: 1.5vw 2vw 1.5vw 2vw;
  background-color: #201b36 !important;
  color: #f0592a !important;
  scale: 1.1;
  font-weight: bold;
  border-color: #FFF !important;
}

.centerButton:hover {
  scale: 1.15;
}

.detailsTitle {
  color: #000000;
  font-weight: bold;
}
.cardViewDetails {
  border-radius: 20px 20px 20px 20px;
}
.cardViewDetails .ant-card-head {
  border-bottom: 1px solid #CBCAD0;
  padding: 1rem;
  background-color: #F6F6F6;
  border-radius: 20px 20px 0px 0px;
}
.cardViewDetails .ant-card-head span {
  word-wrap: break-word;
  word-break: break-word;
  white-space: normal;
  overflow-wrap: break-word;
}

.arrowUpdate {
  list-style: none;
  padding-left: 0;
}

.impact-div {
  padding: 2rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  color: #FFF;
  border-radius: 1rem;
}
.impact-div h6 {
  background-color: rgba(255, 255, 255, 0.01);
  text-align: center;
}

.case-study-bg {
  padding: 1.5rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border-radius: 1rem;
}

.study-details {
  padding: 1.5rem !important;
}
.study-details .spanClassNumber {
  color: #f0592a !important;
  font-weight: bold;
}

/* Remove padding inside col wrapper */
.my-row .ant-col {
  padding: 0;
}

/* Default inner style with border */
.my-col-inner {
  padding: 16px;
  height: 100%;
  border-right: 1px solid #CBCAD0;
  /* default: always has border */
}

/* xs: only 1 col per row – remove all borders */
@media (max-width: 575.98px) {
  .my-row > .ant-col .my-col-inner {
    border-right: none;
  }
  .my-row > .ant-col:nth-child(3n) .my-col-inner {
    border-right: none;
  }
  .my-col-inner {
    padding: 0;
  }
}
/* sm to lg: 2 cols per row – remove border from every 2nd col */
@media (min-width: 576px) and (max-width: 1199.98px) {
  .my-row > .ant-col:nth-child(2n) .my-col-inner {
    border-right: none;
  }
  .my-row > .ant-col:nth-child(3n) .my-col-inner {
    border-right: none;
  }
}
/* xl and up: 3 cols per row – remove border from every 3rd col */
@media (min-width: 1200px) {
  .my-row > .ant-col:nth-child(3n) .my-col-inner {
    border-right: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/ServiceCardView/serviceCardView.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAsDhB;EACI,wBAAA;AApDJ;;AAuDA;EACI,kCAAA;EACA,uBAAA;EACA,qBAAA;AApDJ;;AAyDQ;EACI,6DAAA;EACA,2BAAA;EACA,gCAAA;EACA,cAAA;AAtDZ;AAwDY;EACI;IACI,kBAAA;IACA,mBAAA;EAtDlB;AACF;AA0DQ;EACI,4BAAA;AAxDZ;AA0DY;EACI,6DAAA;EACA,uBAAA;EACA,yBAAA;EACA,YAAA;AAxDhB;AA2DY;EACI,6DAAA;EACA,oCAAA;AAzDhB;AA4DY;EACI,oCAAA;EACA,sBAAA;AA1DhB;AAmEI;EACI,gCAAA;EACA,qBAAA;EACA,iCAAA;EACA,yBAAA;EACA,gCAAA;EACA,mBAAA;AAjER;;AAmBQ;EACI,6DAAA;EACA,2BAAA;EACA,gCAAA;EACA,cAAA;AAhBZ;AAkBY;EACI;IACI,kBAAA;IACA,mBAAA;EAhBlB;AACF;AAoBQ;EACI,4BAAA;AAlBZ;AAoBY;EACI,6DAAA;EACA,uBAAA;EACA,yBAAA;EACA,YAAA;AAlBhB;AAqBY;EACI,6DAAA;EACA,oCAAA;AAnBhB;AAsBY;EACI,oCAAA;EACA,sBAAA;AApBhB;AA6BI;EACI,gCAAA;EACA,qBAAA;EACA,iCAAA;EACA,yBAAA;EACA,gCAAA;EACA,mBAAA;AA3BR;;AAnBQ;EACI,6DAAA;EACA,2BAAA;EACA,gCAAA;EACA,cAAA;AAsBZ;AApBY;EACI;IACI,kBAAA;IACA,mBAAA;EAsBlB;AACF;AAlBQ;EACI,4BAAA;AAoBZ;AAlBY;EACI,6DAAA;EACA,uBAAA;EACA,yBAAA;EACA,YAAA;AAoBhB;AAjBY;EACI,6DAAA;EACA,oCAAA;AAmBhB;AAhBY;EACI,oCAAA;EACA,sBAAA;AAkBhB;AATI;EACI,gCAAA;EACA,qBAAA;EACA,iCAAA;EACA,yBAAA;EACA,gCAAA;EACA,mBAAA;AAWR;;AAzDQ;EACI,6DAAA;EACA,2BAAA;EACA,gCAAA;EACA,cAAA;AA4DZ;AA1DY;EACI;IACI,kBAAA;IACA,mBAAA;EA4DlB;AACF;AAxDQ;EACI,4BAAA;AA0DZ;AAxDY;EACI,6DAAA;EACA,uBAAA;EACA,yBAAA;EACA,YAAA;AA0DhB;AAvDY;EACI,6DAAA;EACA,oCAAA;AAyDhB;AAtDY;EACI,oCAAA;EACA,sBAAA;AAwDhB;AA/CI;EACI,gCAAA;EACA,qBAAA;EACA,iCAAA;EACA,yBAAA;EACA,gCAAA;EACA,mBAAA;AAiDR;;AA/FQ;EACI,6DAAA;EACA,2BAAA;EACA,gCAAA;EACA,cAAA;AAkGZ;AAhGY;EACI;IACI,kBAAA;IACA,mBAAA;EAkGlB;AACF;AA9FQ;EACI,4BAAA;AAgGZ;AA9FY;EACI,6DAAA;EACA,uBAAA;EACA,yBAAA;EACA,YAAA;AAgGhB;AA7FY;EACI,6DAAA;EACA,oCAAA;AA+FhB;AA5FY;EACI,oCAAA;EACA,sBAAA;AA8FhB;AArFI;EACI,gCAAA;EACA,qBAAA;EACA,iCAAA;EACA,yBAAA;EACA,gCAAA;EACA,mBAAA;AAuFR;;AArIQ;EACI,6DAAA;EACA,2BAAA;EACA,gCAAA;EACA,cAAA;AAwIZ;AAtIY;EACI;IACI,kBAAA;IACA,mBAAA;EAwIlB;AACF;AApIQ;EACI,4BAAA;AAsIZ;AApIY;EACI,6DAAA;EACA,uBAAA;EACA,yBAAA;EACA,YAAA;AAsIhB;AAnIY;EACI,6DAAA;EACA,oCAAA;AAqIhB;AAlIY;EACI,oCAAA;EACA,sBAAA;AAoIhB;AA3HI;EACI,gCAAA;EACA,qBAAA;EACA,iCAAA;EACA,yBAAA;EACA,gCAAA;EACA,mBAAA;AA6HR;;AA3KQ;EACI,6DAAA;EACA,2BAAA;EACA,gCAAA;EACA,cAAA;AA8KZ;AA5KY;EACI;IACI,kBAAA;IACA,mBAAA;EA8KlB;AACF;AA1KQ;EACI,4BAAA;AA4KZ;AA1KY;EACI,6DAAA;EACA,uBAAA;EACA,yBAAA;EACA,YAAA;AA4KhB;AAzKY;EACI,6DAAA;EACA,oCAAA;AA2KhB;AAxKY;EACI,oCAAA;EACA,sBAAA;AA0KhB;AAjKI;EACI,gCAAA;EACA,qBAAA;EACA,iCAAA;EACA,yBAAA;EACA,gCAAA;EACA,mBAAA;AAmKR;;AAjNQ;EACI,6DAAA;EACA,2BAAA;EACA,gCAAA;EACA,cAAA;AAoNZ;AAlNY;EACI;IACI,kBAAA;IACA,mBAAA;EAoNlB;AACF;AAhNQ;EACI,4BAAA;AAkNZ;AAhNY;EACI,6DAAA;EACA,uBAAA;EACA,yBAAA;EACA,YAAA;AAkNhB;AA/MY;EACI,6DAAA;EACA,oCAAA;AAiNhB;AA9MY;EACI,oCAAA;EACA,sBAAA;AAgNhB;AAvMI;EACI,gCAAA;EACA,qBAAA;EACA,iCAAA;EACA,yBAAA;EACA,gCAAA;EACA,mBAAA;AAyMR;;AAvPQ;EACI,6DAAA;EACA,2BAAA;EACA,gCAAA;EACA,cAAA;AA0PZ;AAxPY;EACI;IACI,kBAAA;IACA,mBAAA;EA0PlB;AACF;AAtPQ;EACI,4BAAA;AAwPZ;AAtPY;EACI,6DAAA;EACA,uBAAA;EACA,yBAAA;EACA,YAAA;AAwPhB;AArPY;EACI,6DAAA;EACA,oCAAA;AAuPhB;AApPY;EACI,oCAAA;EACA,sBAAA;AAsPhB;AA7OI;EACI,gCAAA;EACA,qBAAA;EACA,iCAAA;EACA,yBAAA;EACA,gCAAA;EACA,mBAAA;AA+OR;;AA7RQ;EACI,6DAAA;EACA,2BAAA;EACA,gCAAA;EACA,cAAA;AAgSZ;AA9RY;EACI;IACI,kBAAA;IACA,mBAAA;EAgSlB;AACF;AA5RQ;EACI,4BAAA;AA8RZ;AA5RY;EACI,6DAAA;EACA,uBAAA;EACA,yBAAA;EACA,YAAA;AA8RhB;AA3RY;EACI,6DAAA;EACA,oCAAA;AA6RhB;AA1RY;EACI,oCAAA;EACA,sBAAA;AA4RhB;AAnRI;EACI,gCAAA;EACA,qBAAA;EACA,iCAAA;EACA,yBAAA;EACA,gCAAA;EACA,mBAAA;AAqRR;;AAnUQ;EACI,6DAAA;EACA,2BAAA;EACA,gCAAA;EACA,cAAA;AAsUZ;AApUY;EACI;IACI,kBAAA;IACA,mBAAA;EAsUlB;AACF;AAlUQ;EACI,4BAAA;AAoUZ;AAlUY;EACI,6DAAA;EACA,uBAAA;EACA,yBAAA;EACA,YAAA;AAoUhB;AAjUY;EACI,6DAAA;EACA,oCAAA;AAmUhB;AAhUY;EACI,oCAAA;EACA,sBAAA;AAkUhB;AAzTI;EACI,gCAAA;EACA,qBAAA;EACA,iCAAA;EACA,yBAAA;EACA,gCAAA;EACA,mBAAA;AA2TR;;AAzWQ;EACI,6DAAA;EACA,2BAAA;EACA,gCAAA;EACA,cAAA;AA4WZ;AA1WY;EACI;IACI,kBAAA;IACA,mBAAA;EA4WlB;AACF;AAxWQ;EACI,4BAAA;AA0WZ;AAxWY;EACI,6DAAA;EACA,uBAAA;EACA,yBAAA;EACA,YAAA;AA0WhB;AAvWY;EACI,6DAAA;EACA,oCAAA;AAyWhB;AAtWY;EACI,oCAAA;EACA,sBAAA;AAwWhB;AA/VI;EACI,gCAAA;EACA,qBAAA;EACA,iCAAA;EACA,yBAAA;EACA,gCAAA;EACA,mBAAA;AAiWR;;AA/YQ;EACI,6DAAA;EACA,2BAAA;EACA,gCAAA;EACA,cAAA;AAkZZ;AAhZY;EACI;IACI,kBAAA;IACA,mBAAA;EAkZlB;AACF;AA9YQ;EACI,4BAAA;AAgZZ;AA9YY;EACI,6DAAA;EACA,uBAAA;EACA,yBAAA;EACA,YAAA;AAgZhB;AA7YY;EACI,6DAAA;EACA,oCAAA;AA+YhB;AA5YY;EACI,oCAAA;EACA,sBAAA;AA8YhB;AArYI;EACI,gCAAA;EACA,qBAAA;EACA,iCAAA;EACA,yBAAA;EACA,gCAAA;EACA,mBAAA;AAuYR;;AArbQ;EACI,6DAAA;EACA,2BAAA;EACA,gCAAA;EACA,cAAA;AAwbZ;AAtbY;EACI;IACI,kBAAA;IACA,mBAAA;EAwblB;AACF;AApbQ;EACI,4BAAA;AAsbZ;AApbY;EACI,6DAAA;EACA,uBAAA;EACA,yBAAA;EACA,YAAA;AAsbhB;AAnbY;EACI,6DAAA;EACA,oCAAA;AAqbhB;AAlbY;EACI,oCAAA;EACA,sBAAA;AAobhB;AA3aI;EACI,gCAAA;EACA,qBAAA;EACA,iCAAA;EACA,yBAAA;EACA,gCAAA;EACA,mBAAA;AA6aR;;AA3dQ;EACI,6DAAA;EACA,2BAAA;EACA,gCAAA;EACA,cAAA;AA8dZ;AA5dY;EACI;IACI,kBAAA;IACA,mBAAA;EA8dlB;AACF;AA1dQ;EACI,4BAAA;AA4dZ;AA1dY;EACI,6DAAA;EACA,uBAAA;EACA,yBAAA;EACA,YAAA;AA4dhB;AAzdY;EACI,6DAAA;EACA,oCAAA;AA2dhB;AAxdY;EACI,oCAAA;EACA,sBAAA;AA0dhB;AAjdI;EACI,gCAAA;EACA,qBAAA;EACA,iCAAA;EACA,yBAAA;EACA,gCAAA;EACA,mBAAA;AAmdR;;AAjgBQ;EACI,6DAAA;EACA,2BAAA;EACA,gCAAA;EACA,cAAA;AAogBZ;AAlgBY;EACI;IACI,kBAAA;IACA,mBAAA;EAogBlB;AACF;AAhgBQ;EACI,4BAAA;AAkgBZ;AAhgBY;EACI,6DAAA;EACA,uBAAA;EACA,yBAAA;EACA,YAAA;AAkgBhB;AA/fY;EACI,6DAAA;EACA,oCAAA;AAigBhB;AA9fY;EACI,oCAAA;EACA,sBAAA;AAggBhB;AAvfI;EACI,gCAAA;EACA,qBAAA;EACA,iCAAA;EACA,yBAAA;EACA,gCAAA;EACA,mBAAA;AAyfR;;AAviBQ;EACI,6DAAA;EACA,2BAAA;EACA,gCAAA;EACA,cAAA;AA0iBZ;AAxiBY;EACI;IACI,kBAAA;IACA,mBAAA;EA0iBlB;AACF;AAtiBQ;EACI,4BAAA;AAwiBZ;AAtiBY;EACI,6DAAA;EACA,uBAAA;EACA,yBAAA;EACA,YAAA;AAwiBhB;AAriBY;EACI,6DAAA;EACA,oCAAA;AAuiBhB;AApiBY;EACI,oCAAA;EACA,sBAAA;AAsiBhB;AA7hBI;EACI,gCAAA;EACA,qBAAA;EACA,iCAAA;EACA,yBAAA;EACA,gCAAA;EACA,mBAAA;AA+hBR;;AA7kBQ;EACI,6DAAA;EACA,2BAAA;EACA,gCAAA;EACA,cAAA;AAglBZ;AA9kBY;EACI;IACI,kBAAA;IACA,mBAAA;EAglBlB;AACF;AA5kBQ;EACI,4BAAA;AA8kBZ;AA5kBY;EACI,6DAAA;EACA,uBAAA;EACA,yBAAA;EACA,YAAA;AA8kBhB;AA3kBY;EACI,6DAAA;EACA,oCAAA;AA6kBhB;AA1kBY;EACI,oCAAA;EACA,sBAAA;AA4kBhB;AAnkBI;EACI,gCAAA;EACA,qBAAA;EACA,iCAAA;EACA,yBAAA;EACA,gCAAA;EACA,mBAAA;AAqkBR;;AAjkBA;EACI,eAAA;EACA,4BAAA;EACA,oCAAA;EACA,yBAAA;EACA,UAAA;EACA,iBAAA;EACA,6BAAA;AAokBJ;;AAjkBA;EACI,WAAA;AAokBJ;;AAjkBA;EACI,cAAA;EACA,iBAAA;AAokBJ;AA/jBA;EACI,kCAAA;AAikBJ;AA/jBI;EACI,gCAAA;EACA,aAAA;EACA,yBAAA;EACA,gCAAA;AAikBR;AA9jBI;EACI,qBAAA;EACA,sBAAA;EACA,mBAAA;EACA,yBAAA;AAgkBR;;AA3jBA;EACI,gBAAA;EACA,eAAA;AA8jBJ;;AA1jBA;EACI,aAAA;EACA,yDAAA;EACA,sBAAA;EACA,4BAAA;EACA,kCAAA;EACA,WAAA;EACA,mBAAA;AA6jBJ;AA3jBI;EACI,2CAAA;EACA,kBAAA;AA6jBR;;AAvjBA;EACI,eAAA;EACA,yDAAA;EACA,sBAAA;EACA,4BAAA;EACA,kCAAA;EACA,mBAAA;AA0jBJ;;AAtjBA;EACI,0BAAA;AAyjBJ;AAvjBI;EACI,yBAAA;EACA,iBAAA;AAyjBR;;AAljBA,sCAAA;AACA;EACI,UAAA;AAqjBJ;;AAljBA,oCAAA;AACA;EACI,aAAA;EACA,YAAA;EACA,+BAAA;EACA,+BAAA;AAqjBJ;;AAljBA,gDAAA;AACA;EACI;IACI,kBAAA;EAqjBN;EAljBE;IACI,kBAAA;EAojBN;EAjjBE;IACI,UAAA;EAmjBN;AACF;AAhjBA,gEAAA;AACA;EACI;IACI,kBAAA;EAkjBN;EA/iBE;IACI,kBAAA;EAijBN;AACF;AA9iBA,iEAAA;AACA;EACI;IACI,kBAAA;EAgjBN;AACF","sourcesContent":["// $gradients: (\n//     linear-gradient(137deg, #FEDED3 0%, #FEF7E2 100%),\n//     linear-gradient(47deg, #E3F5FC 0%, #D4F5F0 100%),\n//     linear-gradient(224deg, #FDEBF3 0%, #EFE7FA 100%),\n// );\n\n\n$gradients: (\n    linear-gradient(135deg, #fff2e6 0%, #ffe3d9 100%),\n    linear-gradient(135deg, #e3efff 0%, #eaf6ff 100%),\n    linear-gradient(135deg, #fdeafb 0%, #ebf0ff 100%),\n    linear-gradient(135deg, #f6ffe0 0%, #e4fbe8 100%),\n    linear-gradient(135deg, #e6fff2 0%, #ebfaff 100%),\n    linear-gradient(135deg, #ffe5e7 0%, #fff1ed 100%),\n    linear-gradient(135deg, #fff7e0 0%, #f1ffff 100%),\n    linear-gradient(135deg, #fff0cc 0%, #ffe5d6 100%),\n    linear-gradient(135deg, #ffe6e0 0%, #fff0ee 100%),\n    linear-gradient(135deg, #ffece3 0%, #fff7f0 100%),\n    linear-gradient(135deg, #e6fbff 0%, #f0f8ff 100%),\n    linear-gradient(135deg, #f0faff 0%, #e6f0ff 100%),\n    linear-gradient(135deg, #fff1ee 0%, #fff0fa 100%),\n    linear-gradient(135deg, #f4f0fb 0%, #fff1fa 100%),\n    linear-gradient(135deg, #fff3f4 0%, #ffecee 100%),\n    linear-gradient(135deg, #ffeaea 0%, #fff4fa 100%),\n    linear-gradient(135deg, #f4fff7 0%, #f7fff9 100%),\n    linear-gradient(135deg, #ffffff 0%, #f6f8fa 100%),\n    linear-gradient(137deg, #FEDED3 0%, #FEF7E2 100%),\n    linear-gradient(137deg, #E3F5FC 0%, #D4F5F0 100%),\n);\n\n$technologies: (\n    #85DBF6,\n    #F5B8FF,\n    #FEC596,\n    #85DBF6,\n    #F5B8FF,\n    #FEC596,\n    #85DBF6,\n    #F5B8FF,\n    #FEC596,\n    #85DBF6,\n    #F5B8FF,\n    #FEC596,\n    #85DBF6,\n    #F5B8FF,\n    #FEC596,\n    #85DBF6,\n    #F5B8FF,\n    #FEC596,\n    #85DBF6,\n    #F5B8FF,\n);\n\n\n.mainDivView {\n    padding: 4vw 6vw 0vw 6vw\n}\n\n.cardView {\n    border-radius: 20px 20px 20px 20px;\n    height: 100% !important;\n    padding: 0 !important;\n}\n\n@for $i from 0 through 17 {\n    .cardView {\n        .cardView#{$i} {\n            background: nth($gradients, $i + 1);\n            padding: 1rem 1rem 0vw 1rem;\n            border-radius: 18px 18px 0px 0px;\n            margin: .2rem;\n\n            @media (max-width:576px) {\n                h5 {\n                    text-align: center;\n                    margin-bottom: 2rem;\n                }\n            }\n        }\n\n        .buttonSection {\n            padding: 1rem 2rem 1rem 2rem;\n\n            .button#{$i} {\n                background: nth($gradients, $i + 1);\n                border: none !important;\n                color: #201b36 !important;\n                float: right;\n            }\n\n            .button#{$i}:hover {\n                background: nth($gradients, $i + 1);\n                border: 1px solid #201b36 !important;\n            }\n\n            button {\n                background-color: #201b36 !important;\n                color: #FFF !important;\n            }\n\n            button:hover {\n                // scale: 1.15;\n            }\n        }\n    }\n\n    .technologies#{$i} {\n        border-color: nth($technologies, $i + 1) !important;\n        margin-bottom: .4rem;\n        background-color: #FFF !important;\n        color: #201b36 !important;\n        padding: .2rem 1rem .2rem 1rem;\n        border-radius: 25px;\n    }\n}\n\n.centerButton {\n    margin-top: 4vw;\n    padding: 1.5vw 2vw 1.5vw 2vw;\n    background-color: #201b36 !important;\n    color: #f0592a !important;\n    scale: 1.10;\n    font-weight: bold;\n    border-color: #FFF !important;\n}\n\n.centerButton:hover {\n    scale: 1.15;\n}\n\n.detailsTitle {\n    color: #000000;\n    font-weight: bold;\n\n    @media (max-width:576px) {}\n}\n\n.cardViewDetails {\n    border-radius: 20px 20px 20px 20px;\n\n    .ant-card-head {\n        border-bottom: 1px solid #CBCAD0;\n        padding: 1rem;\n        background-color: #F6F6F6;\n        border-radius: 20px 20px 0px 0px;\n    }\n\n    .ant-card-head span {\n        word-wrap: break-word;\n        word-break: break-word;\n        white-space: normal;\n        overflow-wrap: break-word;\n    }\n}\n\n\n.arrowUpdate {\n    list-style: none;\n    padding-left: 0;\n}\n\n\n.impact-div {\n    padding: 2rem;\n    background-image: url(\"../../assets/images/home/services/impact.webp\");\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center center;\n    color: #FFF;\n    border-radius: 1rem;\n\n    h6 {\n        background-color: rgba(255, 255, 255, 0.01);\n        text-align: center;\n    }\n}\n\n\n\n.case-study-bg {\n    padding: 1.5rem;\n    background-image: url(\"../../assets/images/home/services/bg_cover.webp\");\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center center;\n    border-radius: 1rem;\n    // color: #FFF !important;\n}\n\n.study-details {\n    padding: 1.5rem !important;\n\n    .spanClassNumber {\n        color: #f0592a !important;\n        font-weight: bold;\n\n    }\n}\n\n\n\n/* Remove padding inside col wrapper */\n.my-row .ant-col {\n    padding: 0;\n}\n\n/* Default inner style with border */\n.my-col-inner {\n    padding: 16px;\n    height: 100%;\n    border-right: 1px solid #CBCAD0;\n    /* default: always has border */\n}\n\n/* xs: only 1 col per row – remove all borders */\n@media (max-width: 575.98px) {\n    .my-row>.ant-col .my-col-inner {\n        border-right: none;\n    }\n\n    .my-row>.ant-col:nth-child(3n) .my-col-inner {\n        border-right: none;\n    }\n\n    .my-col-inner {\n        padding: 0;\n    }\n}\n\n/* sm to lg: 2 cols per row – remove border from every 2nd col */\n@media (min-width: 576px) and (max-width: 1199.98px) {\n    .my-row>.ant-col:nth-child(2n) .my-col-inner {\n        border-right: none;\n    }\n\n    .my-row>.ant-col:nth-child(3n) .my-col-inner {\n        border-right: none;\n    }\n}\n\n/* xl and up: 3 cols per row – remove border from every 3rd col */\n@media (min-width: 1200px) {\n    .my-row>.ant-col:nth-child(3n) .my-col-inner {\n        border-right: none;\n    }\n}\n\n\n\n\n\n\n\n// .cardView {\n//     border-radius: 20px 20px 20px 20px;\n//     height: 100% !important;\n\n//     // .ant-card-head {\n//     //     border-radius: 20px 20px 0px 0px;\n//     //     color: #fff;\n//     //     text-shadow: 0 1px 3px rgba(0, 0, 0, 1);\n//     //     background: var(--gradient-blue-orange,\n//     //             linear-gradient(137deg, #ffb6a0 0%, #f0592a 20%, #253c77 100%));\n//     // }\n\n//     .ant-card-body {\n//         border-radius: 20px 20px 20px 20px;\n//     }\n\n//     a {\n//         color: #253c77 !important;\n//         font-weight: bold;\n//         font-style: italic;\n//         text-shadow: 0 1px 3px rgba(255, 255, 255, 1);\n//     }\n// }\n\n\n\n\n\n\n// .cardViewDetails {\n//     border-radius: 20px 20px 0px 0px;\n\n//     h5 {\n//         color: #f0592a;\n//         font-weight: bold;\n//     }\n\n//     .ant-card-head {\n//         border-radius: 20px 20px 0px 0px;\n//         background: var(--gradient-blue-orange,\n//                 linear-gradient(137deg, #f0592a 0%, #f0592a 20%, #253c77 100%));\n//         color: #fff;\n//         height: 100%;\n\n//     }\n\n//     button {\n//         color: #f0592a !important;\n//         scale: 1.10;\n//         font-weight: bold;\n//     }\n\n//     button:hover {\n//         scale: 1.12;\n//     }\n// }\n\n// .centerButton {\n//     margin-top: 4vw;\n//     padding: 1.5vw 2vw 1.5vw 2vw;\n//     color: #f0592a !important;\n//     scale: 1.10;\n//     font-weight: bold;\n// }\n\n// .centerButton:hover {\n//     scale: 1.15;\n// }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
